"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ChartFilter;
var _react = _interopRequireDefault(require("react"));
var _ChartFilter = require("./ChartFilter.styled");
var _chartOperations = require("../utils/chart-operations");
var _core = require("@mantine/core");
var _constants = require("../constants");
function ChartFilter(_ref) {
  let {
    chart,
    onChange,
    filterValue,
    theme,
    layout
  } = _ref;
  if (!chart.filterCol) {
    return null;
  }
  const column = chart.dataView.columns[chart.filterCol];
  let categories = Object.keys(column.categories).filter(category => column.categories[category].visible).sort((a, b) => column.categories[a].position - column.categories[b].position);
  let component = null;
  if (chart.filterCol === _constants.COL_YEAR) {
    categories = categories.filter(year => column.categories[year].aggregate || Number(year) >= Number(chart.dataView.earliestYear) && Number(year) <= Number(chart.dataView.latestYear));
  }
  const isDate = chart.filterCol === _constants.COL_DATE;
  if (layout === "print") {
    const category = categories.find(category => category === filterValue);
    component = category && /*#__PURE__*/_react.default.createElement(_core.Text, {
      size: "lg",
      weight: "bold"
    }, column.categories[category].label);
  } else if (chart.filterDisplay === "parent") {
    return null;
  } else if (!isDate && (chart.filterDisplay === "buttons" || chart.filterDisplay === "auto" && categories.length <= 3 && categories.length > 0)) {
    const options = categories.map((category, idx) => ({
      label: column.categories[category].label,
      value: category
    }));
    component = /*#__PURE__*/_react.default.createElement(_core.SegmentedControl, {
      data: options,
      onChange: onChange,
      value: filterValue
    });
  } else if (isDate || chart.filterDisplay === "slider" || column.type === "temporal" && chart.filterDisplay === "auto") {
    if (isDate) {
      var _chart$dataView$data$;
      categories = (_chart$dataView$data$ = chart.dataView.data[0]) === null || _chart$dataView$data$ === void 0 ? void 0 : _chart$dataView$data$.points.map(p => p[chart.filterCol]).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    }
    const values = categories.reduce((obj, date) => {
      return {
        ...obj,
        [date]: isDate ? (0, _chartOperations.stringToTimestamp)(date) : Number(date)
      };
    }, {});
    let marks = categories.filter((date, idx) => idx <= Math.round(categories.length * 0.8) && idx % Math.round(categories.length / 4) === 0 || idx === categories.length - 1).map(date => ({
      value: values[date],
      label: isDate ? formattedDateFromInput(date) : column.categories[date].label,
      date
    }));
    const min = Math.min(...marks.map(mark => mark.value));
    const max = Math.max(...marks.map(mark => mark.value));
    const range = max - min;
    marks = marks.map(mark => ({
      label: mark.label,
      value: (mark.value - min) * 100 / range,
      date: mark.date
    }));
    const steps = categories.map((date, idx) => ({
      value: (values[date] - min) * 100 / range,
      idx
    }));
    const step = 100 / (steps.length - 1);
    component = /*#__PURE__*/_react.default.createElement("div", {
      style: {
        padding: "16px"
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Slider, {
      marks: marks,
      step: step,
      onChange: value => onChange(isDate ? categories[findClosestsIdx(value, steps)] : categories[findClosestsIdx(value, steps)]),
      style: {
        maxWidth: "50%",
        margin: "auto"
      },
      styles: {
        markLabel: {
          fontSize: "0.7rem"
        }
      },
      label: value => isDate ? formattedDateFromInput(categories[findClosestsIdx(value, steps)]) : categories[findClosestsIdx(value, steps)],
      value: filterValue ? (values[filterValue] - min) * 100 / range : 0
    }));
  } else {
    const options = categories.map(category => ({
      value: category,
      label: column.categories[category].label
    }));
    component = /*#__PURE__*/_react.default.createElement(_core.Select, {
      data: options,
      onChange: onChange,
      value: filterValue,
      style: {
        maxWidth: "50%",
        margin: "auto"
      },
      searchable: options.length > 20
    });
  }
  return /*#__PURE__*/_react.default.createElement(_core.MantineProvider, {
    theme: {
      colors: {
        // @ts-ignore
        'blue': Array.from({
          length: 10
        }, (val, idx) => theme.colors.main)
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_ChartFilter.FilterContainer, null, component));
}
function formattedDateFromInput(inputDate) {
  const [year, month] = inputDate.split('-');
  const dateObj = new Date(Number(year), Number(month) - 1);
  const monthName = dateObj.toLocaleString('en-US', {
    month: 'short'
  });
  const formattedDate = "".concat(monthName, " ").concat(year);
  return formattedDate;
}
function findClosestsIdx(value, steps) {
  for (let i = 0; i < steps.length; i++) {
    var _steps;
    if (value >= steps[i].value && value < ((_steps = steps[i + 1]) === null || _steps === void 0 ? void 0 : _steps.value)) {
      return Math.abs(value - steps[i].value) < Math.abs(value - steps[i + 1].value) ? steps[i].idx : steps[i + 1].idx;
    }
  }
  return steps.at(-1).idx;
}